import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import styles from './Popup.module.css'

function Popup(props) {
    document.body.style.overflow = "hidden"

    useEffect(() => {
        return (function() {
            document.body.style.overflow = "auto"
        })
    })

    return ReactDOM.createPortal(
        <div className={styles.Popup} onClick={(e) => {
        }}>
            <div className={styles.container} onClick={(e) => {
                e.stopPropagation()
            }}>
                <props.component {...props} />
            </div>
        </div>,
        document.body
    )
}

export default Popup
